// 작업을 동시 실행 수 제한 안에서 돌린다. 결과는 입력 순서, 하나라도 실패하면 즉시 reject 하고 새 작업을
// 시작하지 않는다(틀린 비밀번호를 첫 실패에서 알리고 남은 복호화를 이어 가지 않기 위해).
// 복호화 진행률 창이 쓰는 onProgress(완료 건수, 전체) 를 위해 decryptRecords 에서 분리했다 — 의존성 zero 로 두어
// crypto.subtle 이 없는 jest 환경에서도 진행 카운트를 검증할 수 있다.
export const runWithConcurrency = (items, worker, { concurrency = 10, onProgress } = {}) =>
  new Promise((resolve, reject) => {
    // 빈 입력은 즉시 끝낸다 — 그대로 두면 작업이 하나도 시작되지 않아 Promise 가 영원히 끝나지 않는다
    if (items.length === 0) {
      resolve([])
      return
    }
    const results = new Array(items.length)
    let started = 0
    let completed = 0
    let failed = false

    const run = () => {
      if (failed || started === items.length) return
      const index = started
      started += 1
      worker(items[index])
        .then((value) => {
          if (failed) return
          results[index] = value
          completed += 1
          if (onProgress) onProgress(completed, items.length)
          if (completed === items.length) resolve(results)
          else run()
        })
        .catch((error) => {
          failed = true
          reject(error)
        })
    }

    Array.from({ length: Math.min(concurrency, items.length) }, run)
  })

export default runWithConcurrency
